import {Component, OnInit} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentProductLine} from "../services/shipment-product-line";
import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

@Component({
    selector: 'app-shipment-help',
    templateUrl: './shipment-help.component.html',
    styleUrls: ['./shipment-help.component.scss']
})
export class ShipmentHelpComponent implements OnInit {
    public shipmentStates: any[];


    public dummyProductLines: ShipmentProductLine[] = [

        ShipmentProductLine.fromJSON({
            id: '1',
            shipment_id: '1',
            external_reference: '2',
            number: 10,
            product_number: 1234,
            product_number_ean: '1234',
            product_text_1: '',
            product_text_2: '',
            product_text_3: '',
            amount: 10,
            unit: 'stk',
            status: 'string',
            shipment_status_formatted: 'string',
            note: 'string',
            note_modified: moment(),
            created: moment(),
            modified: moment(),
            stock_updated: moment(),
            stock_reserved: 90,
            stock: 9000,
            purchase_order: null,
            amount_picked: 0
        }), ShipmentProductLine.fromJSON({
            id: '1',
            shipment_id: '1',
            external_reference: '2',
            number: 10,
            product_number: 1234,
            product_number_ean: '1234',
            product_text_1: '',
            product_text_2: '',
            product_text_3: '',
            amount: 10,
            unit: 'stk',
            status: 'string',
            shipment_status_formatted: 'string',
            note: 'string',
            note_modified: moment(),
            created: moment(),
            modified: moment(),
            stock_updated: moment(),
            stock_reserved: 90,
            stock: 2,
            purchase_order: null,
            amount_picked: 0
        }), ShipmentProductLine.fromJSON({
            id: '1',
            shipment_id: '1',
            external_reference: '2',
            number: 10,
            product_number: 1234,
            product_number_ean: '1234',
            product_text_1: '',
            product_text_2: '',
            product_text_3: '',
            amount: 10,
            unit: 'stk',
            status: 'string',
            shipment_status_formatted: 'string',
            note: 'string',
            note_modified: moment(),
            created: moment(),
            modified: moment(),
            stock_updated: moment(),
            stock_reserved: 90,
            stock: 0,
            purchase_order: null,
            amount_picked: 0
        }), ShipmentProductLine.fromJSON({
            id: '1',
            shipment_id: '1',
            external_reference: '2',
            number: 10,
            product_number: 1234,
            product_number_ean: '1234',
            product_text_1: '',
            product_text_2: '',
            product_text_3: '',
            amount: 10,
            unit: 'stk',
            status: 'string',
            shipment_status_formatted: 'string',
            note: 'string',
            note_modified: moment(),
            created: moment(),
            modified: moment(),
            stock_updated: null,
            stock_reserved: 90,
            stock: 0,
            purchase_order: null,
            amount_picked: 0
        }),

    ]

    constructor(public shipmentsService: ShipmentsService) {
    }

    ngOnInit(): void {
        this.shipmentsService.getShipmentEventStates().then((results) => {
            this.shipmentStates = results.results;
        })
    }

}
